/**
 * @generated SignedSource<<6963d0ce75f7d6eedaacaae0975186c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SurveyFinishQuery$variables = {};
export type SurveyFinishQuery$data = {
  readonly userData: {
    readonly firstName: string | null;
  } | null;
};
export type SurveyFinishQuery = {
  response: SurveyFinishQuery$data;
  variables: SurveyFinishQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SurveyFinishQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SurveyFinishQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "63827b7c97fc8dde7e316b048409aded",
    "id": null,
    "metadata": {},
    "name": "SurveyFinishQuery",
    "operationKind": "query",
    "text": "query SurveyFinishQuery {\n  userData {\n    firstName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "370c582326c5dc45799ec701441c02d9";

export default node;
